// Ditampilkan di halaman login. Samakan dengan "version" di package.json
// kalau salah satunya diubah.
export const APP_VERSION = '2.0.0'
export const BUILD_YEAR = 2026
